import { render } from "./Loader.vue?vue&type=template&id=2536e13a"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=2536e13a&lang=css"
script.render = render

export default script